export const ROLES = {
  ADMIN: 'administrator',
  RECRUITER: 'recruiter',
  MANAGER: 'manager',
  SUPPORT: 'support',
};

export const USER_GROUPS_FOR_RECRUITER = [
  { label: 'Менеджер', value: 'manager' },
  { label: 'Рекрутер', value: 'recruiter' },
  { label: 'Сотрудник поддержки', value: 'support' },
];

export const USER_GROUPS_FOR_ADMIN = [
  ...USER_GROUPS_FOR_RECRUITER,
  { label: 'Администратор', value: 'administrator' },
];
